import type { DocMigration } from "../docMigration";

// eslint-disable-next-line @typescript-eslint/naming-convention
const migration_0_0_174: DocMigration = {
  maxSchemaVersion: "0.0.174",
  description: "Adds setting to toggle ceiling open-to-above annotation on for existing homes",
  apply(json: any) {
    for (const settingId in json.settings) {
      const setting = json.settings[settingId];
      if (setting.type === "PLAN_SETTINGS") {
        if (setting["enableOpenToAboveAnnotation"] === undefined) {
          setting["enableOpenToAboveAnnotation"] = true;
        }
      }
    }
    return json;
  },
};

export default migration_0_0_174;
